import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUButton4EU',
	friendly_name: 'BLU Button 4 EU',
	family: 'inputs_reader',
	isPM: false,
	modes: {
		inputs_reader: {
			availableViews: ['basic', 'advanced'],
			channels: 4,
			notifications: ['device_problem', 'lowBattery'],
			bluetooth_settings: [
				{ title: 'beacon_mode', component: 'beacon_ble' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
